import { useTranslation } from "react-i18next";

import { CapsuleButton } from "../../../Everou/_components";
import ToolTipWrapper from "../../../Everou/_components/ToolTipWrapper";
import { LocalEditableIntegration } from "../../../Everou/_modelsTS/Integration";

type AddIntegrationButtonProps = {
    integrations: LocalEditableIntegration[];
    isEnabled: boolean;
    onClick: () => void;
};

// The page-level "add" action, shared by every platform that supports more than
// one account.
//
// Hidden until the first integration is saved: the list always starts with an
// empty card (integrationsByCompany seeds one), so the button would greet a new
// account disabled, with no way to guess why. Once something is saved it stays
// visible, and while an unsaved card is on screen it is disabled — adding
// half-finished rows is what BAC-314 was about — and says so on hover.
export function AddIntegrationButton({
    integrations,
    isEnabled,
    onClick,
}: AddIntegrationButtonProps) {
    const { t } = useTranslation();

    const hasSavedIntegrations = integrations.some(({ uid }) => !!uid);
    if (!hasSavedIntegrations) return null;

    return (
        <ToolTipWrapper tooltip={isEnabled ? null : t("mod_integrations_add_disabled_tooltip")}>
            <div>
                <CapsuleButton
                    isEnabled={isEnabled}
                    onClick={onClick}
                    text={t("global_add")}
                    size="SMALL"
                />
            </div>
        </ToolTipWrapper>
    );
}
